import { FormInputBase } from './form-input.js';
import { on } from '@ember/modifier';
import { concat } from '@ember/helper';
import { useStyles } from '@frontile/theme';
import FormField from './form-field.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

class FormTextarea extends FormInputBase {
  get classes() {
    const {
      formInput
    } = useStyles();
    const {
      base,
      label,
      input,
      hint,
      feedback
    } = formInput({
      size: this.args.size
    });
    return {
      base: base({
        class: this.args.containerClass
      }),
      label: label(),
      input: input({
        class: this.args.inputClass
      }),
      hint: hint(),
      feedback: feedback()
    };
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <FormField @size={{@size}} class={{this.classes.base}} as |f|>\n      {{#if @label}}\n        <f.Label @class={{this.classes.label}}>\n          {{@label}}\n        </f.Label>\n      {{/if}}\n\n      {{#if @hint}}\n        <f.Hint @class={{this.classes.hint}}>\n          {{@hint}}\n        </f.Hint>\n      {{/if}}\n\n      <f.Textarea {{on \"focus\" this.handleFocusIn}} {{on \"blur\" this.handleFocusOut}} @onInput={{@onInput}} @onChange={{@onChange}} @value={{@value}} @class={{this.classes.input}} aria-invalid={{if this.showErrorFeedback \"true\"}} aria-describedby=\"{{if @hint f.hintId}}{{if this.showErrorFeedback (concat \" \" f.feedbackId)}}\" ...attributes />\n\n      {{yield}}\n\n      {{#if this.showErrorFeedback}}\n        <f.Feedback @class={{this.classes.feedback}} @errors={{@errors}} />\n      {{/if}}\n    </FormField>\n  ", {
      strictMode: true,
      scope: () => ({
        FormField,
        concat,
        on
      })
    }), this);
  }
}

export { FormTextarea as default };
//# sourceMappingURL=form-textarea.js.map
